import {
	type ClientPropertyHouseDetailResponseDTO,
	ClientPropertyTypeEnum,
} from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { BuildingEditFormFields } from "web_myplann/Portfolio/Forms/BuildingShared/BuildingEditFormFields";
import { useEditHouseForm } from "web_myplann/Portfolio/Forms/HouseForm/useEditHouseForm";
import { PortfolioFormShell } from "web_myplann/Portfolio/PortfolioShared/PortfolioFormShell";

type EditHouseFormProps = {
	propertyId: number;
	property: ClientPropertyHouseDetailResponseDTO;
	detailRoute: string;
};

export const EditHouseForm = ({
	propertyId,
	property,
	detailRoute,
}: EditHouseFormProps) => {
	const { t } = useResource();
	const { form, onSubmit, isPending, leaveConfirmation } = useEditHouseForm({
		propertyId,
		property,
		detailRoute,
	});

	return (
		<PortfolioFormShell
			onSubmit={onSubmit}
			submitLabel={t(Resources.Portfolio.EditRealEstate.submit)}
			disabled={!form.formState.isDirty}
			loading={isPending}
			leaveConfirmation={leaveConfirmation}
		>
			<BuildingEditFormFields
				control={form.control}
				type={ClientPropertyTypeEnum.House}
			/>
		</PortfolioFormShell>
	);
};
